import { APPLICATION_FETCHED, APPLICATIONS_FETCHED, TOGGLE_NOTIFICATION, FETCH_BEGIN, FETCH_END, APPLICATIONS_FILTERED } from "utils/constants";
import _ from 'lodash';

const dispatchApplication = (dispatch) => (data) => {
  return dispatch({
    type: APPLICATION_FETCHED,
    data: { application: data.application }
  });
}

const dispatchApplications = (dispatch) => (data) => {
  return dispatch({
    type: APPLICATIONS_FETCHED,
    data: { applications: data.applications || data }
  });
}

export const fetchApplication = (appNumber, params=null) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: FETCH_BEGIN});

  api.fetchApplication(appNumber, params)
    .then((data) => {
      dispatchApplication(dispatch)(data);
      dispatch({type: FETCH_END});
    })
}

export const fetchApplications = (params=null) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: FETCH_BEGIN});

  api.fetchApplications(params)
    .then((data) => {
      dispatchApplications(dispatch)(data);
      dispatch({type: FETCH_END});
    })
}

export const createApplication = (params, callback=null) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: FETCH_BEGIN});

  api.createApplication(params)
    .then((data) => {
      dispatchApplication(dispatch)(data);
      dispatch({type: FETCH_END});
      if (callback) {
        callback(data.application.number);
      }
    })
}

export const updateApplication = ({appNumber, updateOrLodge, callback, notificationMsg}) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch({type: FETCH_BEGIN});
  const formValues = getState().form.applicationForm.values;
  const directorParams = { numberOfPersons: 1, person1: { fullName: formValues.name, email: formValues.contactEmail, mobile: formValues.contactNumber, personType: 'referral' } };
  const params = updateOrLodge === 'lodge' ? { ...formValues, lodged: true, termsAndConditions: true } : formValues;

  api.updateApplication(appNumber, { ...params, ...directorParams })
    .then((data) => {
      dispatchApplication(dispatch)(data);
      dispatch({type: FETCH_END, data: {notificationMsg: notificationMsg}});
      if (callback) {
        callback();
      }
    })
}

export const filterApplications = (params) => (dispatch, getState) => {
  const applications = getState().applications.list;
  let data = applications;
  const term = Object.values(params)[0];
  const field = Object.keys(params)[0];

  if (term.length > 3) {
    data = applications.filter(app=>(_.toString(_.get(app, field)).toLowerCase().includes(term.toLowerCase())));
    dispatch({
      type: APPLICATIONS_FILTERED,
      data: { filteredApplications: data }
    });
  } else {
    dispatch({
      type: APPLICATIONS_FILTERED,
      data: { filteredApplications: [] }
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/applications.js